import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const Label = styled.label`
  color: ${({ theme }) => theme.palette.input.label};
  font-weight: 600;
  > div {
    display: flex;
    .input-field {
      flex-grow: 1;
    }
  }
`;

const Wrapper = styled.div`
  display: block;
  ${Label} {
    > div {
      ${({ noBorder }) => noBorder && 'border-bottom: none;'}
    }
  }
`;
const Error = styled.span`
  display: block;
  color: ${({ theme }) => theme.palette.input.error};
  font-weight: 700;
  margin-top: ${({ theme }) => theme.spacing}px ;
  svg {
    height: 1.25em;
    width: 1.25em;
    margin-right: ${({ theme }) => theme.spacing}px ;
  }
`;

const InputBase = ({
  label, error, className, noBorder, children, ...rest
}) => {
  const classes = ['InputBase'];
  if (className) {
    classes.push(className);
  }
  return (
    <Wrapper
      className={classes.join(' ')}
      noBorder={noBorder}
      {...rest}
    >
      <Label error={!!error}>
        {label}
        <div className="input-field">
          {children}
        </div>
      </Label>
      {error && (
        <Error>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {error}
        </Error>
      )}
    </Wrapper>
  );
};

InputBase.displayName = 'InputBase';

InputBase.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  noBorder: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

InputBase.defaultProps = {
  error: null,
  className: null,
  noBorder: false,
};

export default InputBase;
